export type MemberSection =
  | 'landing'
  | 'onboarding-snapshot'
  | 'regenerative-medicine-ops'
  | 'annual-report'
  | 'composite-report'
  | 'action-plan'
  | 'ai-tools'
  | 'rule-action-audit'
  | 'labs'
  | 'documents'
  | 'surveys'
  | 'omics-explorer'
  | 'member-app'
  | 'pulse';

export const MEMBER_SECTION_STORAGE_KEY = 'memberDetail.lastSection';
